const config = {
    API: 'https://smart-meter-iot-server.onrender.com'
}

export default config